var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41107 4.41073C4.73651 4.0853 5.26414 4.0853 5.58958 4.41073L10.0003 8.82148L14.4111 4.41073C14.7365 4.0853 15.2641 4.0853 15.5896 4.41073C15.915 4.73617 15.915 5.26381 15.5896 5.58925L11.1788 9.99999L15.5896 14.4107C15.915 14.7362 15.915 15.2638 15.5896 15.5892C15.2641 15.9147 14.7365 15.9147 14.4111 15.5892L10.0003 11.1785L5.58958 15.5892C5.26414 15.9147 4.73651 15.9147 4.41107 15.5892C4.08563 15.2638 4.08563 14.7362 4.41107 14.4107L8.82181 9.99999L4.41107 5.58925C4.08563 5.26381 4.08563 4.73617 4.41107 4.41073Z",
    fill: "#5D5E6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.9cc3546193782dd72b4a3bbe3aeeaea9.svg";
export { ForwardRef as ReactComponent };